module.exports = __webpack_public_path__ + "img/tool8.33be2bd1.png";